import { inject, Injectable } from '@angular/core'
import { injectMutation, injectQuery, injectQueryClient } from '@ngneat/query'
import { HttpClient } from '@angular/common/http'
import { CalendarProviderName, User } from './users.service'
import { Organization } from './organizations.service'
import { queryKeys } from './query-keys'
import { JoinSettings } from './settings-page/settings-page.component'

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  mutation = injectMutation()
  httpClient = inject(HttpClient)
  query = injectQuery()
  queryClient = injectQueryClient()

  getUserSettings() {
    return this.query({
      queryKey: queryKeys.users.settings,
      queryFn: () => this.httpClient.get<User & { joinSettings: JoinSettings }>('/api/users/me'),
    }).result$
  }

  getOrganizationSettings() {
    return this.query({
      queryKey: queryKeys.organizations.settings,
      queryFn: () => this.httpClient.get<Organization>('/api/organizations/me'),
    }).result$
  }

  updateUserSettings() {
    return this.mutation({
      mutationFn: (user: User) => this.httpClient.patch<User>(`/api/users/me`, user),
      onSuccess: () => this.queryClient.invalidateQueries({ queryKey: queryKeys.users.me }),
    })
  }

  updateOrganizationSettings() {
    return this.mutation({
      mutationFn: (organization: Organization) => this.httpClient.patch<Organization>(`/api/organizations/me`, organization),
      onSuccess: () => this.queryClient.invalidateQueries({ queryKey: queryKeys.organizations.me }),
    })
  }

  unlinkCalendarProviderMutation() {
    return this.mutation({
      mutationFn: ({ provider }: { provider: CalendarProviderName }) => this.httpClient.delete<any>(`/api/users/me/calendar/${provider}`),
      onSuccess: () => this.queryClient.invalidateQueries({ queryKey: queryKeys.users.settings }),
    })
  }
}
